import { render, staticRenderFns } from "./site-development-applied-for.vue?vue&type=template&id=9d0f525c"
import script from "./site-development-applied-for.vue?vue&type=script&lang=js"
export * from "./site-development-applied-for.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports